import React from "react";
import { TextField } from "@mui/material";
import { useStrataPlanValidation } from "./hooks/useStrataPlanValidation";

interface StrataPlanInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const StrataPlanInput: React.FC<StrataPlanInputProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const { strataPlanError, handleInputChange } = useStrataPlanValidation();

  return (
    <TextField
      margin="dense"
      label="Strata Plan Number"
      helperText={
        strataPlanError || "Either address or strata plan number is required"
      }
      error={!!strataPlanError}
      fullWidth
      value={value}
      onChange={(e) => {
        handleInputChange(e);
        onChange(e.target.value);
      }}
      disabled={disabled}
      data-testid="strata-plan-input"
    />
  );
};
